import request from '@/utils/service'
//
export function parkingList() {
  let data = {
    parkingName: '',
  }
  return request({
    url: '/parking/parking/parkingList?parkingName=' + data.parkingName,
    method: 'get',
    noToken: true,
  })
}
// 登录接口
export function parkingListH5() {
  return request({
    url: '/nbhparking/parking/parking/parkingListH5', //线上地址
    // url: '/parking/parking/parkingListH5', //测试的地址
    method: 'get',
    noToken: true,
  })
}
